export default [
	{
		code: 'AP001',
		description: {
			es: 'Vitrocerámica',
			en: 'Electric Hob',
			ca: 'Vitroceràmica'
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR007',
			'MR008',
			'MR009',
			'MR013',
			'MR017',
			'MR018',
			'MR019',
			'MR030',
			'MR037',
			'MR039',
			'MR042',
			'MR043',
			'MR054',
			'MR056',
			'MR063',
			'MR064'
		]
	},
	{
		code: 'AP002',
		description: {
			es: 'Frigorífico',
			en: 'Fridge',
			ca: 'Frigorífic'
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR007',
			'MR008',
			'MR009',
			'MR013',
			'MR017',
			'MR018',
			'MR019',
			'MR029',
			'MR030',
			'MR034',
			'MR035',
			'MR037',
			'MR039',
			'MR041',
			'MR043',
			'MR044',
			'MR049',
			'MR050',
			'MR054',
			'MR056',
			'MR062',
			'MR063',
			'MR064'
		]
	},
	{
		code: 'AP003',
		description: {
			es: 'Lavadora',
			en: 'Washing Machine',
			ca: 'Rentadora'
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR007',
			'MR008',
			'MR009',
			'MR013',
			'MR017',
			'MR018',
			'MR019',
			'MR029',
			'MR030',
			'MR034',
			'MR035',
			'MR037',
			'MR039',
			'MR041',
			'MR043',
			'MR044',
			'MR049',
			'MR050',
			'MR054',
			'MR056',
			'MR062',
			'MR063',
			'MR064'
		]
	},
	{
		code: 'AP004',
		description: {
			es: 'Lavavajillas',
			en: 'Dishwasher', 
			ca: 'Rentavaixelles' 
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR007',
			'MR008',
			'MR009',
			'MR013',
			'MR017',
			'MR018',
			'MR019',
			'MR029',
			'MR030',
			'MR034',
			'MR035',
			'MR037',
			'MR039',
			'MR041',
			'MR043',
			'MR044',
			'MR049',
			'MR050',
			'MR054',
			'MR056',
			'MR062',
			'MR063',
			'MR064'
		]
	},
	{
		code: 'AP005',
		description: {
			es: 'Televisor', 
			en: 'Television', 
			ca: 'Televisor'
		},
		brands: [
			'MR001',
			'MR003',
			'MR006',
			'MR014',
			'MR015',
			'MR025',
			'MR027',
			'MR028',
			'MR034',
			'MR036',
			'MR043',
			'MR045',
			'MR046',
			'MR047',
			'MR050',
			'MR051',
			'MR053',
			'MR055',
			'MR057',
			'MR058',
			'MR059',
			'MR060'
		]
	},
	{
		code: 'AP006',
		description: {
			es: 'Cocina/Horno', 
			en: 'Cooker/Oven',  
			ca: 'Cuina/Forn'   
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR007',
			'MR008',
			'MR009',
			'MR013',
			'MR017',
			'MR018',
			'MR019',
			'MR030',
			'MR031',
			'MR037',
			'MR038',
			'MR042',
			'MR043',
			'MR054',
			'MR056',
			'MR063',
			'MR064'
		]
	},
	{
		code: 'AP007',
		description: {
			es: 'Caldera De Gas',
			en: 'Gas Boiler',
			ca: 'Caldera De Gas'
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR011',
			'MR012',
			'MR013',
			'MR017',
			'MR019',
			'MR020',
			'MR022',
			'MR033',
			'MR043',
			'MR048',
			'MR052',
			'MR056',
			'MR061'
		]
	},
	{
		code: 'AP008',
		description: {
			es: 'Aire Acondicionado',
			en: 'Air Conditioner', 
			ca: 'Aire Condicionat'
		},
		brands: [
			'MR002',
			'MR005',
			'MR008',
			'MR010',
			'MR019',
			'MR021',
			'MR023',
			'MR024',
			'MR026',
			'MR032',
			'MR034',
			'MR040',
			'MR043',
			'MR046',
			'MR048',
			'MR049',
			'MR050',
			'MR052'
		]
	},
	{
		code: 'AP009',
		description: {
			es: 'Termo Eléctrico',
			en: 'Electric Thermo', 
			ca: 'Terme Elèctric'  
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR011',
			'MR012',
			'MR013',
			'MR017',
			'MR019',
			'MR020',
			'MR022',
			'MR033',
			'MR043',
			'MR048',
			'MR052',
			'MR056',
			'MR061'
		]
	},
	{
		code: 'AP010',
		description: {
			es: 'Campana Extractora', 
			en: 'Extractor Hood',  
			ca: 'Campana Extractora'
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR007',
			'MR008',
			'MR009',
			'MR013',
			'MR017',
			'MR018',
			'MR019',
			'MR030',
			'MR031',
			'MR037',
			'MR038',
			'MR042',
			'MR043',
			'MR054',
			'MR056',
			'MR063',
			'MR064'
		]
	},
	{
		code: 'AP011',
		description: {
			es: 'Secadora',
			en: 'Dryer',
			ca: 'Secadora'
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR007',
			'MR008',
			'MR009',
			'MR013',
			'MR017',
			'MR018',
			'MR019',
			'MR029',
			'MR030',
			'MR034',
			'MR035',
			'MR037',
			'MR039',
			'MR041',
			'MR043',
			'MR044',
			'MR049',
			'MR050',
			'MR054',
			'MR056',
			'MR062',
			'MR063',
			'MR064'
		]
	},
	{
		code: 'AP012',
		description: {
			es: 'Microondas',
			en: 'Microwaves',
			ca: 'Microones'
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR007',
			'MR008',
			'MR009',
			'MR013',
			'MR017',
			'MR018',
			'MR019',
			'MR029',
			'MR030',
			'MR034',
			'MR035',
			'MR037',
			'MR039',
			'MR041',
			'MR043',
			'MR044',
			'MR049',
			'MR050',
			'MR054',
			'MR056',
			'MR062',
			'MR063',
			'MR064'
		]
	},
	{
		code: 'AP013',
		description: {
			es: 'Caldera De Gasoil',
			en: 'Diesel Boiler',
			ca: 'Caldera De Gasoil'
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR011',
			'MR012',
			'MR013',
			'MR017',
			'MR019',
			'MR020',
			'MR022',
			'MR033',
			'MR043',
			'MR048',
			'MR052',
			'MR056',
			'MR061'
		]
	},
	{
		code: 'AP014',
		description: {
			es: 'Ordenador Sobremesa',
			en: 'Desktop Computer',
			ca: 'Ordinador Sobretaula'
		},
		brands: [
			'MR001',
			'MR003',
			'MR006',
			'MR014',
			'MR015',
			'MR025',
			'MR027',
			'MR028',
			'MR034',
			'MR036',
			'MR043',
			'MR045',
			'MR046',
			'MR047',
			'MR050',
			'MR051',
			'MR053',
			'MR055',
			'MR057',
			'MR058',
			'MR059',
			'MR060'
		]
	},
	{
		code: 'AP015',
		description: {
			es: 'Portátil',
			en: 'Laptop',
			ca: 'Portàtil'
		},
		brands: [
			'MR001',
			'MR003',
			'MR006',
			'MR014',
			'MR015',
			'MR025',
			'MR027',
			'MR028',
			'MR034',
			'MR036',
			'MR043',
			'MR045',
			'MR046',
			'MR047',
			'MR050',
			'MR051',
			'MR053',
			'MR055',
			'MR057',
			'MR058',
			'MR059',
			'MR060'
		]
	},
	{
		code: 'AP016',
		description: {
			es: 'Calentador De Butano',
			en: 'Butane Boiler', 
			ca: 'Escalfador De Butà'
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR011',
			'MR012',
			'MR013',
			'MR017',
			'MR019',
			'MR020',
			'MR022',
			'MR033',
			'MR043',
			'MR048',
			'MR052',
			'MR056',
			'MR061'
		]
	},
	{
		code: 'AP017',
		description: {
			es: 'Tablet',
			en: 'Tablets',
			ca: 'Tablet'
		},
		brands: [
			'MR001',
			'MR003',
			'MR006',
			'MR014',
			'MR015',
			'MR025',
			'MR027',
			'MR028',
			'MR034',
			'MR036',
			'MR043',
			'MR045',
			'MR046',
			'MR047',
			'MR050',
			'MR051',
			'MR053',
			'MR055',
			'MR057',
			'MR058',
			'MR059',
			'MR060'
		]
	},
	{
		code: 'AP018',
		description: {
			es: 'Calderas Eléctricas',
			en: 'Electric Boiler',
			ca: 'Calderes Elèctriques'
		},
		brands: [
			'MR002',
			'MR004',
			'MR005',
			'MR011',
			'MR012',
			'MR013',
			'MR017',
			'MR019',
			'MR020',
			'MR022',
			'MR033',
			'MR043',
			'MR048',
			'MR052',
			'MR056',
			'MR061'
		]
	},
	{
		code: 'AP019',
		description: {
			es: 'Otros',
			en: 'Others',
			ca: 'Altres'
		},
		brands: [
			'MR001',
			'MR003',
			'MR006',
			'MR014',
			'MR015',
			'MR025',
			'MR027',
			'MR028',
			'MR034',
			'MR036',
			'MR043',
			'MR045',
			'MR046',
			'MR047',
			'MR050',
			'MR051',
			'MR053',
			'MR055',
			'MR057',
			'MR058',
			'MR059',
			'MR060'
		]
	}
];
